import { notification } from "../Components/notification";
import * as types from "./actionTypes";
import { STATE_SALE_ID } from "./cookiesActions";

const bearer = (state, headers) => {
  var user = state.oidc.user;

  if (user && user.access_token) {
    headers.append("Authorization", "Bearer " + user.access_token);
  }
};

export const removePayment = (key, newCheckout) => (dispatch, getState) => {
  const state = getState();
  const cookies = state.cookies;
  const apiUri = state.config.apiUri;
  const saleId = cookies[STATE_SALE_ID];
  const uri = `${apiUri}/sales/${saleId}/payments/${key}`;

  const options = {
    method: "DELETE",
    headers: new Headers(),
  };

  bearer(state, options.headers);

  const promise = fetch(uri, options);

  dispatch({
    type: types.REMOVE_PAYMENT,
    promise,
  });

  if (!newCheckout) {
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }
};

const commitImpl = (data, uri, state) => {
  const options = {
    method: "POST",
    body: JSON.stringify(data),
    headers: new Headers({
      "Content-Type": "application/json",
    }),
  };

  bearer(state, options.headers);

  return fetch(uri, options);
};

export const commitOnePage =
  (data, uri, successCb, errorCb) => (dispatch, getState) => {
    const state = getState();

    const promise = commitImpl(data, uri, state).then((response) => {
      if (response.status !== 200) {
        response.text().then((text) => {
          errorCb(text);
          return dispatch({
            type: types.ERROR,
            payload: text,
          });
        });
      } else {
        successCb();
      }
    });

    return {
      type: types.COMMIT,
      promise,
    };
  };

export const commit = (data, uri, successCb, cb) => (dispatch, getState) => {
  const state = getState();

  const promise = commitImpl(data, uri, state).then((response) => {
    if (response.status === 201) {
      successCb();
      var location = response.headers.get("Location");
      window.location = location;
    } else {
      response.text().then((text) => {
        if (text.split(" ")[0] === "Expired") {
          let expiredDate;
          let expiredMsg;
          expiredDate = text.split(" ").splice(-2, 2).join();
          expiredMsg = `${
            state.language.GiftCertificateIsExpired
          } ${expiredDate.replace(",", " ")}`;
          notification("error", expiredMsg);
        } else {
          cb(text);
          notification(
            "error",
            "GiftCertificateIsEmpty"
              ? state.language.GiftCertificateIsEmpty
              : state.language.GiftCertificateNotFound
          );

          return dispatch({
            type: types.ERROR,
            payload: text,
          });
        }
      });
    }
  });

  return {
    type: types.COMMIT,
    promise,
  };
};
